import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  CalendarDays,
  PackageCheck,
  ShieldCheck,
  Sparkles,
} from "lucide-react";
import { formatCurrency } from "./stuffAdapters";
import "./SubscriptionsPage.css";

const SubscriptionDetails = () => {
  const navigate = useNavigate();

  return (
    <section className="subscriptions-page">
      <section className="subscriptions-sheet">
        <header className="subscriptions-sheet-header">
          <div>
            <span>SUBSCRIPTION DETAILS</span>
            <h2>Salar Shopping Voucher</h2>
          </div>
          <button
            type="button"
            onClick={() => navigate("/Subscriptions")}
            aria-label="Back to subscriptions"
          >
            <ArrowLeft size={19} strokeWidth={2} />
          </button>
        </header>

        <div className="subscriptions-sheet-status-row">
          <span className="subscriptions-status subscriptions-status-active">
            Active
          </span>
          <span>
            <CalendarDays size={14} strokeWidth={2} />
            01-08-2025
          </span>
        </div>

        <section className="subscriptions-sheet-product">
          <div className="subscriptions-sheet-product-image">
            <img
              src="../../assets/img/mobiles/mobiles-4.png"
              alt="Salar Shopping Voucher"
            />
          </div>
          <div>
            <span>PRODUCT</span>
            <h3>Salar Shopping Voucher</h3>
            <p>
              Premium subscription benefit with a one-year validity
              period.
            </p>
            <strong>{formatCurrency(22000)}</strong>
          </div>
        </section>

        <section className="subscriptions-sheet-card">
          <div className="subscriptions-sheet-section-title">
            <span>
              <Sparkles size={17} strokeWidth={2} />
            </span>
            <h3>Subscription Information</h3>
          </div>
          <div className="subscriptions-sheet-detail-grid">
            <div>
              <span>Date</span>
              <strong>01-08-2025</strong>
            </div>
            <div>
              <span>Order No</span>
              <strong>SKN-123456HNGBMN</strong>
            </div>
            <div>
              <span>Price</span>
              <strong>{formatCurrency(22000)}</strong>
            </div>
            <div>
              <span>Status</span>
              <span className="subscriptions-status subscriptions-status-active">
                Active
              </span>
            </div>
          </div>
        </section>

        <section className="subscriptions-sheet-card">
          <div className="subscriptions-sheet-section-title">
            <span>
              <PackageCheck size={17} strokeWidth={2} />
            </span>
            <h3>Product Information</h3>
          </div>
          <div className="subscriptions-sheet-product-mini-grid">
            <div>
              <span>Product Name</span>
              <strong>Salar Shopping Voucher</strong>
            </div>
            <div>
              <span>Quantity</span>
              <strong>1 item</strong>
            </div>
            <div>
              <span>Validity</span>
              <strong>1 Year</strong>
            </div>
          </div>
        </section>

        <section className="subscriptions-sheet-card">
          <div className="subscriptions-sheet-section-title">
            <span>
              <CalendarDays size={17} strokeWidth={2} />
            </span>
            <h3>Validity Period</h3>
          </div>
          <div className="subscriptions-sheet-validity-grid">
            <div>
              <span>Start Date</span>
              <strong>10-10-2025</strong>
            </div>
            <div>
              <span>End Date</span>
              <strong>10-10-2026</strong>
            </div>
          </div>
        </section>

        <div className="subscriptions-sheet-protection">
          <ShieldCheck size={16} strokeWidth={2} />
          <span>
            Subscription benefits are linked to your Salar account.
          </span>
        </div>
      </section>
    </section>
  );
};

export default SubscriptionDetails;
